"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'route.company.list': 'Firmy',
    'route.company.create': 'Dodaj firmę',
    'route.company.edit': 'Edytuj firmę',
};
